import { Box, Flex, Heading, Text } from '@chakra-ui/react'

export function PageHeader({ title, subtitle, children }) {
  return (
    <Flex align="center" gap={4} wrap="wrap" mb={6}>
      <Box>
        <Heading color="var(--mc-text)" fontFamily="'DM Sans', sans-serif" size={{ base: 'md', md: 'lg' }}>{title}</Heading>
        {subtitle && <Text color="var(--mc-text-muted)" fontSize="sm">{subtitle}</Text>}
      </Box>
      <Box flex="1" />
      {children}
    </Flex>
  )
}
